import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	projectsTitle: {
		id: 'platform.ui.breadcrumbs.common-breadcrumbs.project.projects-title',
		defaultMessage: 'Projects',
		description: 'Title of the breadcrumb that navigates to projects directory page',
	},
});
